import { Component, OnInit } from '@angular/core';
import {EntregadorService} from "../../services/entregador.service";
import {AnalisePedidosService} from "../../services/analise-pedidos.service";

declare var google;

@Component({
  selector: 'app-tela-analise-pedidos',
  templateUrl: './tela-analise-pedidos.component.html',
  styleUrls: ['./tela-analise-pedidos.component.scss']
})
export class TelaAnalisePedidosComponent implements OnInit {
  static readonly DIAS_MAXIMO_PERIODO = 31;
  private readonly DISTANCIA_MAXIMA_AGRUPAMENTO_ENTREGAS_METROS = 350;
  periodoEspecifico = true;
  filtro: any = {
    inicio: new Date(),
    fim: new Date()
  };
  hoje: Date = new Date();
  avisoPeriodo = '';
  valorMes: any;
  entregadores: any = [{id: "Todos", nome: "Todos"}];
  desempenhoEntregas: any;
  carregandoDesempenho: boolean;
  erroDesempenho = '';
  mapaAnaliseEntregas: any;
  marcadoresAnaliseEntregas: any[] = [];
  infoWindowsAnaliseEntregas: any[] = [];
  erroMapaAnaliseEntregas = '';
  idRequisicaoDesempenho = 0;
  agruparEntregasProximas = true;

  constructor(private analisePedidosService: AnalisePedidosService, private entregadorService: EntregadorService) {
    this.filtro.inicio.setHours(0, 0, 0, 0)
    this.filtro.fim.setHours(23, 59, 59)
  }

  ngOnInit(): void {
    this.carregueEntregadores()
    this.carregueDesempenhoEntregas()
  }

  carregueEntregadores() {
    this.entregadorService.liste().then((entregadores) => {
      if(entregadores.length > 0) {
        this.entregadores = [{id: "Todos", nome: "Todos"}, {id: "", nome: "----"}].concat(entregadores)
        this.filtro.entregador = this.entregadores[0]
      }
    })
  }

  carregueDesempenhoEntregas() {
    if(!this.filtro.inicio || !this.filtro.fim)
      return

    const idRequisicao = ++this.idRequisicaoDesempenho;
    this.carregandoDesempenho = true
    this.erroDesempenho = ''
    this.analisePedidosService.obtenhaDesempenho(this.filtro.inicio, this.filtro.fim,
      this.filtro.entregador).then((desempenhoEntregas) => {
      if(idRequisicao !== this.idRequisicaoDesempenho)
        return

      this.desempenhoEntregas = desempenhoEntregas
      this.erroDesempenho = ''
      this.carregandoDesempenho = false
      setTimeout(() => this.renderizeMapaAnaliseEntregas())
    }).catch((erro: any) => {
      if(idRequisicao === this.idRequisicaoDesempenho) {
        this.desempenhoEntregas = null
        this.erroDesempenho = this.obtenhaMensagemErroDesempenho(erro)
        this.carregandoDesempenho = false
      }
    })
  }

  private obtenhaMensagemErroDesempenho(erro: any) {
    if(typeof erro === 'string')
      return erro

    if(erro && erro.message)
      return erro.message

    return 'Não foi possível carregar a análise de entregas no momento.'
  }

  exibirPeriodoEspecifico() {
    this.periodoEspecifico = true
  }

  carregueRelatorio() {
    this.carregueDesempenhoEntregas()
  }

  exibirPeriodoMensal() {
    this.periodoEspecifico = false;
    if(!this.valorMes)
      this.valorMes = new Date(this.filtro.inicio || new Date())

    this.mudouValorMes(this.valorMes)
  }

  mudouValorMes(mes: Date) {
    if(!mes)
      return

    this.avisoPeriodo = ''
    this.valorMes = mes
    this.filtro.inicio = new Date(mes.getFullYear(), mes.getMonth(), 1, 0, 0, 0, 0)
    this.filtro.fim = new Date(mes.getFullYear(), mes.getMonth() + 1, 0, 23, 59, 59, 999)
    this.carregueRelatorio()
  }

  get maxFim(): Date {
    if(!this.filtro.inicio)
      return this.hoje

    const limite = new Date(this.filtro.inicio.getTime() +
      TelaAnalisePedidosComponent.DIAS_MAXIMO_PERIODO * 24 * 60 * 60 * 1000)

    return limite < this.hoje ? limite : this.hoje
  }

  mudouInicio(inicio: Date) {
    if(!inicio)
      return

    this.filtro.inicio = inicio
    this.ajustePeriodoAoLimite('inicio')
    this.carregueRelatorio()
  }

  mudouFim(fim: Date) {
    if(!fim)
      return

    this.filtro.fim = fim
    this.ajustePeriodoAoLimite('fim')
    this.carregueRelatorio()
  }

  private ajustePeriodoAoLimite(alterado: 'inicio' | 'fim') {
    this.avisoPeriodo = ''

    if(!this.filtro.inicio || !this.filtro.fim)
      return

    const limiteMs = TelaAnalisePedidosComponent.DIAS_MAXIMO_PERIODO * 24 * 60 * 60 * 1000
    const spanMs = this.filtro.fim.getTime() - this.filtro.inicio.getTime()

    if(spanMs <= limiteMs)
      return

    if(alterado === 'inicio')
      this.filtro.fim = new Date(this.filtro.inicio.getTime() + limiteMs)
    else
      this.filtro.inicio = new Date(this.filtro.fim.getTime() - limiteMs)

    this.avisoPeriodo = `O período foi ajustado para ${TelaAnalisePedidosComponent.DIAS_MAXIMO_PERIODO} dias, o máximo permitido por análise.`
  }

  mudouEntregador(entregador: any) {
    this.filtro.entregador = entregador
    this.carregueRelatorio()
  }

  busqueEntregadores(nome: any) {

  }

  formateMinutos(valor: any) {
    if(valor === null || valor === undefined)
      return 'Sem dados'

    return valor + ' min'
  }

  formatePercentual(valor: any) {
    if(valor === null || valor === undefined)
      return 'Sem dados'

    return valor + '%'
  }

  obtenhaEntregasMapa() {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.mapa)
      return []

    return (this.desempenhoEntregas.mapa.entregas || []).slice(0, 40)
  }

  obtenhaTentativasForaAreaMapa() {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.mapa)
      return []

    return (this.desempenhoEntregas.mapa.tentativasForaArea || []).slice(0, 20)
  }

  obtenhaBairrosMapa() {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.mapa)
      return []

    return (this.desempenhoEntregas.mapa.bairros || []).slice(0, 20)
  }

  obtenhaTemPontosMapa() {
    return this.obtenhaEntregasMapa().length > 0 ||
      this.obtenhaBairrosMapa().length > 0 ||
      this.obtenhaTentativasForaAreaMapa().length > 0
  }

  alterneAgrupamentoEntregasProximas() {
    this.agruparEntregasProximas = !this.agruparEntregasProximas
    this.renderizeMapaAnaliseEntregas()
  }

  obtenhaGruposEntregasProximas(entregas: any[] = this.obtenhaEntregasMapa()) {
    const grupos: any[] = []

    ;(entregas || []).forEach((entrega: any) => {
      if(!this.localizacaoValida(entrega?.localizacao))
        return

      if(!this.agruparEntregasProximas) {
        grupos.push({
          localizacao: {lat: entrega.localizacao.lat, lng: entrega.localizacao.lng},
          entregas: [entrega]
        })
        return
      }

      const grupoProximo = grupos.find((grupo: any) =>
        this.calculeDistanciaMetros(grupo.localizacao, entrega.localizacao) <=
        this.DISTANCIA_MAXIMA_AGRUPAMENTO_ENTREGAS_METROS)

      if(grupoProximo) {
        grupoProximo.entregas.push(entrega)
        grupoProximo.localizacao = this.obtenhaCentroEntregas(grupoProximo.entregas)
        return
      }

      grupos.push({
        localizacao: {lat: entrega.localizacao.lat, lng: entrega.localizacao.lng},
        entregas: [entrega]
      })
    })

    return grupos
  }

  usaMapaAproximado() {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.localizacao)
      return false

    return (this.desempenhoEntregas.localizacao.estimada || 0) > 0 ||
      (this.desempenhoEntregas.localizacao.estimadaEndereco || 0) > 0 ||
      (this.desempenhoEntregas.localizacao.estimadaBairro || 0) > 0
  }

  obtenhaTotalLocalizacaoAproximada() {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.localizacao)
      return 0

    return this.desempenhoEntregas.localizacao.estimada ||
      ((this.desempenhoEntregas.localizacao.estimadaEndereco || 0) +
        (this.desempenhoEntregas.localizacao.estimadaBairro || 0))
  }

  obtenhaUltimasEntregas(): any[] {
    if(!this.desempenhoEntregas || !this.desempenhoEntregas.pedidos)
      return []

    return this.desempenhoEntregas.pedidos.slice(0, 15)
  }

  obtenhaDescricaoLocalizacao(pedido: any) {
    if(!pedido)
      return 'Sem localização'

    if(pedido.tipoLocalizacao === 'registrada')
      return 'Registrada'
    if(pedido.tipoLocalizacao === 'estimada_endereco')
      return 'Aprox. endereço'
    if(pedido.tipoLocalizacao === 'estimada_bairro')
      return 'Aprox. bairro'

    return 'Sem localização'
  }

  async renderizeMapaAnaliseEntregas() {
    const elemento = document.getElementById('mapa-analise-pedidos');
    const entregas = this.obtenhaEntregasMapa();
    const gruposEntregas = this.obtenhaGruposEntregasProximas(entregas);
    const bairros = this.obtenhaBairrosMapa();
    const tentativasForaArea = this.obtenhaTentativasForaAreaMapa();

    this.erroMapaAnaliseEntregas = ''
    this.limpeMarcadoresAnaliseEntregas()

    if(!elemento || (!entregas.length && !bairros.length && !tentativasForaArea.length)) {
      this.mapaAnaliseEntregas = null
      return
    }

    if(typeof google === 'undefined' || !google.maps) {
      this.erroMapaAnaliseEntregas = 'Mapa indisponível no momento.'
      return
    }

    // @ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const primeiroPonto = (entregas[0] || bairros[0] || tentativasForaArea[0]).localizacao;

    if(!this.mapaAnaliseEntregas) {
      this.mapaAnaliseEntregas = new Map(elemento as HTMLElement, {
        center: {lat: primeiroPonto.lat, lng: primeiroPonto.lng},
        zoom: 13,
        mapTypeControl: false,
        streetViewControl: false
      });
    }

    // @ts-ignore
    const bounds = new google.maps.LatLngBounds();

    gruposEntregas.forEach((grupo: any) => {
      if(grupo.entregas.length === 1)
        this.adicioneMarcadorAnaliseEntrega(grupo.entregas[0], bounds, false)
      else
        this.adicioneMarcadorGrupoAnaliseEntrega(grupo, bounds)
    })

    bairros.forEach((bairro: any) => {
      this.adicioneMarcadorBairroAnaliseEntrega(bairro, bounds)
    })

    tentativasForaArea.forEach((tentativa: any) => {
      this.adicioneMarcadorAnaliseEntrega(tentativa, bounds, true)
    })

    if(this.marcadoresAnaliseEntregas.length === 1)
      this.mapaAnaliseEntregas.setZoom(14)
    else
      this.mapaAnaliseEntregas.fitBounds(bounds)
  }

  private adicioneMarcadorAnaliseEntrega(item: any, bounds: any, foraArea: boolean) {
    const position = {lat: item.localizacao.lat, lng: item.localizacao.lng};
    const titulo = foraArea ? (item.erro || 'Tentativa fora da área') :
      ('Pedido #' + item.codigoPedido + ' - ' + item.nomeEntregador)
    const aproximado = item.tipoLocalizacao === 'estimada_endereco';
    const cor = foraArea ? '#a855f7' : (aproximado ? '#4f7bd9' : '#ff8a1f')

    // @ts-ignore
    const marker = new google.maps.Marker({
      position,
      map: this.mapaAnaliseEntregas,
      title: titulo,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: foraArea ? 8 : 9,
        fillColor: cor,
        fillOpacity: 0.95,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      label: {
        text: foraArea ? '!' : (aproximado ? '~' : 'P'),
        color: '#ffffff',
        fontSize: '12px'
      }
    });

    // @ts-ignore
    const infoWindow = new google.maps.InfoWindow({
      content: foraArea ?
        `<strong>Tentativa fora da área</strong><br>${item.endereco || ''}<br>${item.erro || ''}` :
        `<strong>Pedido #${item.codigoPedido}</strong><br>${item.precisaoLocalizacao || ''}<br>${item.nomeEntregador || ''}<br>${item.endereco || ''}`
    });

    marker.addListener('click', () => {
      this.infoWindowsAnaliseEntregas.forEach((info: any) => info.close())
      infoWindow.open(this.mapaAnaliseEntregas, marker)
    })

    this.marcadoresAnaliseEntregas.push(marker)
    this.infoWindowsAnaliseEntregas.push(infoWindow)
    bounds.extend(position)
  }

  private adicioneMarcadorGrupoAnaliseEntrega(grupo: any, bounds: any) {
    const position = {lat: grupo.localizacao.lat, lng: grupo.localizacao.lng};
    const quantidade = grupo.entregas.length;

    // @ts-ignore
    const marker = new google.maps.Marker({
      position,
      map: this.mapaAnaliseEntregas,
      title: quantidade + ' entregas próximas',
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: Math.min(18, 11 + quantidade),
        fillColor: '#f97316',
        fillOpacity: 0.95,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      label: {
        text: String(quantidade),
        color: '#ffffff',
        fontSize: '13px',
        fontWeight: '600'
      }
    });

    // @ts-ignore
    const infoWindow = new google.maps.InfoWindow({
      content: this.monteConteudoGrupoEntrega(grupo)
    });

    marker.addListener('click', () => {
      this.infoWindowsAnaliseEntregas.forEach((info: any) => info.close())
      infoWindow.open(this.mapaAnaliseEntregas, marker)
    })

    this.marcadoresAnaliseEntregas.push(marker)
    this.infoWindowsAnaliseEntregas.push(infoWindow)
    bounds.extend(position)
  }

  private adicioneMarcadorBairroAnaliseEntrega(bairro: any, bounds: any) {
    const position = {lat: bairro.localizacao.lat, lng: bairro.localizacao.lng};
    const raio = Math.min(2400, 500 + (bairro.pedidos || 1) * 120);

    // @ts-ignore
    const circle = new google.maps.Circle({
      strokeColor: '#14b8a6',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#14b8a6',
      fillOpacity: 0.18,
      map: this.mapaAnaliseEntregas,
      center: position,
      radius: raio
    });

    // @ts-ignore
    const marker = new google.maps.Marker({
      position,
      map: this.mapaAnaliseEntregas,
      title: bairro.bairro,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: '#14b8a6',
        fillOpacity: 0.95,
        strokeColor: '#ffffff',
        strokeWeight: 2
      },
      label: {
        text: String(bairro.pedidos || 1),
        color: '#ffffff',
        fontSize: '12px'
      }
    });

    // @ts-ignore
    const infoWindow = new google.maps.InfoWindow({
      content: `<strong>${bairro.bairro}</strong><br>${bairro.precisaoLocalizacao || 'Localização aproximada por bairro'}<br>${bairro.pedidos || 0} pedido(s)`
    });

    marker.addListener('click', () => {
      this.infoWindowsAnaliseEntregas.forEach((info: any) => info.close())
      infoWindow.open(this.mapaAnaliseEntregas, marker)
    })

    this.marcadoresAnaliseEntregas.push(circle)
    this.marcadoresAnaliseEntregas.push(marker)
    this.infoWindowsAnaliseEntregas.push(infoWindow)
    bounds.extend(position)
  }

  private limpeMarcadoresAnaliseEntregas() {
    this.marcadoresAnaliseEntregas.forEach((marker: any) => marker.setMap(null))
    this.infoWindowsAnaliseEntregas.forEach((info: any) => info.close())
    this.marcadoresAnaliseEntregas = []
    this.infoWindowsAnaliseEntregas = []
  }

  private monteConteudoGrupoEntrega(grupo: any) {
    const entregas = grupo.entregas || []
    const itens = entregas.slice(0, 8).map((entrega: any) =>
      `<br><strong>Pedido #${entrega.codigoPedido}</strong>` +
      `<br>${entrega.nomeEntregador || ''}` +
      `<br>${entrega.endereco || ''}`).join('')
    const restantes = entregas.length > 8 ? `<br>+ ${entregas.length - 8} pedido(s)` : ''

    return `<strong>${entregas.length} entregas próximas</strong>` +
      `<br>Raio de agrupamento: ${this.DISTANCIA_MAXIMA_AGRUPAMENTO_ENTREGAS_METROS}m` +
      `${itens}${restantes}`
  }

  private obtenhaCentroEntregas(entregas: any[]) {
    const total = entregas.reduce((soma: any, entrega: any) => {
      soma.lat += Number(entrega.localizacao.lat)
      soma.lng += Number(entrega.localizacao.lng)
      return soma
    }, {lat: 0, lng: 0})

    return {
      lat: total.lat / entregas.length,
      lng: total.lng / entregas.length
    }
  }

  private localizacaoValida(localizacao: any) {
    return localizacao &&
      Number.isFinite(Number(localizacao.lat)) &&
      Number.isFinite(Number(localizacao.lng))
  }

  private calculeDistanciaMetros(origem: any, destino: any) {
    const raioTerraMetros = 6371000
    const latOrigem = this.convertaGrausParaRadianos(Number(origem.lat))
    const latDestino = this.convertaGrausParaRadianos(Number(destino.lat))
    const diferencaLat = this.convertaGrausParaRadianos(Number(destino.lat) - Number(origem.lat))
    const diferencaLng = this.convertaGrausParaRadianos(Number(destino.lng) - Number(origem.lng))
    const haversine = Math.sin(diferencaLat / 2) * Math.sin(diferencaLat / 2) +
      Math.cos(latOrigem) * Math.cos(latDestino) *
      Math.sin(diferencaLng / 2) * Math.sin(diferencaLng / 2)

    return raioTerraMetros * 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
  }

  private convertaGrausParaRadianos(graus: number) {
    return graus * Math.PI / 180
  }
}
